var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('n-dropdown',{attrs:{"type":"text","custom-text":_vm.customText,"items":_vm.items,"padding":"10px 15px 10px 7px","is-user-info":""},on:{"on-click":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }